import { render } from "./dataTypeDefinition.vue?vue&type=template&id=18487898&ts=true"
import script from "./dataTypeDefinition.vue?vue&type=script&lang=ts"
export * from "./dataTypeDefinition.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__